import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { saveUserSites } from "actions/Users";
import { useModal } from "context/ModalContext";
import LoadingIndicator from "components/LoadingIndicator";
import TableNew from "components/TableNew";
import ButtonContained from "components/ButtonContained";

const UserSettingsFacilitiesModal = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { closeModal } = useModal();
  const user = useSelector(state => state.users.userObject);
  const site = useSelector(state => state.auth.site);
  const authUser = useSelector(state => state.auth.authUser);
  const [selectedSites, setSelectedSites] = useState(user?.sites.map((s) => s.uuid) || []);

  useEffect(() => {
    if (user?.sites) {
      setSelectedSites(user.sites.map((s) => s.uuid));
    }
  }, [user]);

  const noChanges = JSON.stringify(selectedSites.sort()) === JSON.stringify(user?.sites.map((s) => s.uuid).sort());

  const handleSave = () => {
    const originalSites = user?.sites.map((s) => s.uuid) || [];
    const addedSites = selectedSites.filter((site) => !originalSites.includes(site));
    const removedSites = originalSites.filter((site) => !selectedSites.includes(site));
    const roles = addedSites.map((siteUUID) => ({
      uuid: user.role.uuid,
      siteUUID,
    }));
    // did we remove them from the current site
    const noMore = removedSites.includes(site.uuid);
    const overwrite = {
      successMessage: intl.formatMessage({ id: "notifications.success.edit" }),
      refetch: noMore ? false : true
    }
    dispatch(saveUserSites(user.uuid, roles, removedSites, false, overwrite));
    if (noMore) {
      closeModal();
    }
  };

  const handleCancel = () => {
    setSelectedSites(user?.sites.map((s) => s.uuid) || []);
  };

  return (
    <div className="min-h-[300px] max-h-[60vh] px-10 pt-4 flex flex-col justify-between">
      <div>
        <h5 className="tw-heading-5 mb-8">{intl.formatMessage({ id: "pages.sites.Types" })}</h5>
      </div>
      {user ? <>
        <TableNew
          data={authUser?.sites.filter(s => s.companyUUID === site.companyUUID) || []}
          defaultSortKey="name"
          searchableKeys={["name"]}
          multiSelect={true}
          showHeaders={false}
          onSelectionChange={(selected) => setSelectedSites(selected)}
          preSelectedRows={user?.sites.map(s => s.uuid) || []}
          maxHeight="max-h-[250px]"
          columns={[
            {
              key: "name",
              label: "Name"
            },
            {
              key: "city",
              label: "City",
              width: "180px"
            }
          ]}
        />
        <div className="flex gap-2 py-4">
          <ButtonContained
            id="User-Settings-Facilities-Save-Button"
            dataCy="User-Settings-Facilities-Save-Button"
            text={intl.formatMessage({ id: `comp.button.save` })}
            type="medium"
            disabled={noChanges}
            onClick={handleSave}
          />
          <ButtonContained
            id="User-Settings-Facilities-Cancel-Button"
            dataCy="User-Settings-Facilities-Cancel-Button"
            text={intl.formatMessage({ id: `comp.button.cancel` })}
            type="mediumOutline"
            disabled={noChanges}
            onClick={handleCancel}
          />
        </div>
      </> :
      <div className="flex-1 flex items-center justify-center">
        <LoadingIndicator />
      </div>}
    </div>
  )
};

export default UserSettingsFacilitiesModal;